import { render, staticRenderFns } from "./view-guard.vue?vue&type=template&id=28ab3130&scoped=true"
import script from "./view-guard.vue?vue&type=script&lang=js"
export * from "./view-guard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab3130",
  null
  
)

export default component.exports